import {FC} from 'react'

import {Link} from '@/i18n'
import {theme} from '@/theme/theme'

import {Text} from '../common/content/Text'
import {Checkbox} from './Checkbox'

type ConsentCheckboxProps = {
  name: string
  consentText: string
  linkUrl?: string
  linkText?: string
  color?: string
  isDisabled?: boolean
}

export const ConsentCheckbox: FC<React.PropsWithChildren<ConsentCheckboxProps>> = ({
  name,
  consentText,
  linkUrl,
  linkText,
  color = theme.palette.text.default,
  isDisabled,
}) => {
  return (
    <>
      <div className="wrapper" data-test="consentCheckbox">
        <Checkbox
          name={name}
          isBoolean
          label={
            <Text color={color}>
              {consentText}
              {linkUrl && linkText && (
                <>
                  {' '}
                  <Link href={linkUrl} legacyBehavior>
                    <a className="link" target="_blank">
                      {linkText}
                    </a>
                  </Link>
                </>
              )}
            </Text>
          }
          isDisabled={isDisabled}
        />
      </div>

      <style jsx>{`
        .wrapper + .wrapper {
          margin-top: ${theme.spacing[3]};
        }
        .link {
          color: inherit;
          font-weight: ${theme.fontWeight.medium};
          text-decoration: underline;
        }
        .link:hover {
          text-decoration: none;
        }
      `}</style>
    </>
  )
}
